import styled from 'styled-components';
import { contextColors as colors } from '@/data/colors';

const ColoredLine = styled.div<{
  variant: 'current' | 'intermediate' | 'aggressive';
}>(({ variant }) => ({
  height: 0,
  width: '16px',
  borderBottom: `2px solid ${colors[variant]}`,
}));

export { ColoredLine };
